import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    youAreStaking: 'You are staking',
    youWillReceive: 'You will receive',

    exchangeRate: 'Exchange rate',
    feeTooltip:
      '<b style="font-weight: 600; margin-bottom: 0.5rem; color: #fff;">Staking fee</b><br />Lombard does not charge additional fees',
    stakingFee: 'Staking fee',
    incentives: {
      title: 'Incentives',
      tooltip:
        '<b style="font-weight: 600; margin-bottom: 0.5rem; color: #fff;">Incentives</b><br />Your stake will earn Lombard Lux immediately, and minted LBTC can be used as collateral for lending, borrowing, and trading. Any additional partner incentives will be issued retrospectively.',
      descr: 'Babylon, Lombard, Berachain & Concrete',
    },
    confirmationTime: 'Confirmation time',
    confirmationTimeValue: '~{minutes} minutes ({blocks} blocks)',

    waitingForDeposit: 'Waiting for your deposit',
  },
};
